import { times } from "lodash";

// Preenche o início da collection com value.
// Útil para as empresas que entaram no ACL e não
// tem ainda 12 meses completos de histórico.
export const fulfillWith = (collection, value) => {
  const diff = 12 - collection.length;

  if (diff === 0) {
    return collection;
  } else {
    return [...times(diff, () => value), ...collection];
  }
};



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/utils.js